import { render, staticRenderFns } from "./QuoteBuilderMiscItemTemplate.vue?vue&type=template&id=96454a3e"
import script from "./QuoteBuilderMiscItemTemplate.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderMiscItemTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderMiscItemTemplate.vue?vue&type=style&index=0&id=96454a3e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96454a3e')) {
      api.createRecord('96454a3e', component.options)
    } else {
      api.reload('96454a3e', component.options)
    }
    module.hot.accept("./QuoteBuilderMiscItemTemplate.vue?vue&type=template&id=96454a3e", function () {
      api.rerender('96454a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/templates/QuoteBuilderMiscItemTemplate.vue"
export default component.exports